import type { SavedRecipe } from '../data/types';
import styles from './Welcome.module.css';

interface WelcomeProps {
  saved: SavedRecipe[];
  onBegin: () => void;
  onLoad: (id: string) => void;
  onDelete: (id: string) => void;
}

export function Welcome({ saved, onBegin, onLoad, onDelete }: WelcomeProps) {
  return (
    <section className={styles.welcome}>
      <h1 className={styles.heading}>the aftercare recipe</h1>
      <p className={styles.subtitle}>a tailored plan for after</p>
      <p className={styles.body}>
        answer eight quick prompts. get back a recipe card with what you'll need,
        what to do in the first thirty minutes, what to keep in mind for the next
        few hours, and a note about drop. save as many as you like — one for each
        kind of scene.
      </p>
      <button type="button" className={styles.begin} onClick={onBegin}>
        begin
      </button>

      {saved.length > 0 && (
        <section className={styles.savedSection} aria-label="saved recipes">
          <h2 className={styles.savedHeading}>your saved recipes</h2>
          <ul className={styles.savedList}>
            {saved.map((r) => (
              <li key={r.id} className={styles.savedItem}>
                <button
                  type="button"
                  className={styles.savedTitleBtn}
                  onClick={() => onLoad(r.id)}
                >
                  {r.name || r.plan.title}
                </button>
                <button
                  type="button"
                  className={styles.deleteBtn}
                  onClick={() => {
                    if (confirm('delete this recipe?')) onDelete(r.id);
                  }}
                  aria-label={`delete ${r.name || r.plan.title}`}
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </section>
  );
}
